<template>
  <section>
    <div
      id="alertdisconnectedpages"
      ref="alertdisconnectedpages"
      class="modal fade"
      tabindex="-1"
      :style="!isShow ? 'display: none;' : 'display: block;'"
      :class="isShow ? 'd-flex align-items-center justify-content-center': ''"
      aria-hidden="true"
      aria-labelledby="alertdisconnectedpages"
      data-backdrop="static" 
      data-keyboard="false"
    >
      <div
        class="modal-dialog d-flex align-items-center justify-content-center"
        style="height: 100vh; max-width: 100vw; margin: 0;"
      >
        <div 
          class="modal-content"
          style="width: 37rem;"
        >
          <div class="d-flex flex-column align-items-center justify-content-center p-0">
            <img
              :src="
                $storeIndex.getImageSvgAssets(
                  'circle-exclamation-alert'
                )
              "
              class="img-fluid"
              style="margin: 20px;"
              alt=""
              width="80"
              height="80"
            >
            <div
              class="list-news flex-column"
            >
              <div 
                class="d-flex flex-column align-items-center justify-content-center" 
              >
                <span class="title-alert-disconnect">
                  {{ $t("Integration Expiration") }}
                </span>

                <div
                  class="box-contain-disconnected-page-warning"
                  style="margin-top: 12px;"
                >
                  <div class="contain-red">
                    <i
                      class="fa-solid fa-triangle-exclamation"
                      style="color: #fff; width: 20px; height: 20px; font-size: 20px;"
                    />
                  </div>
                  <div class="contain-lighter-red">
                    <span>
                      {{ $t("Found") }} {{ $store.state.itemsPageDisconnected.length }} {{ $t("of your integrations have access token about to expire or has expired according to the partner's conditions.To continue using, please click to 'Manage Integration' and reauthorize. If an integration has been expired for more than 15 days, your integration will be automatically deleted.") }}
                    </span>
                  </div>
                </div>

                <div class="d-flex flex-row align-items-center justify-content-center mt-3">
                  <button
                    type="button"
                    class="btn btn-primary btn-normal-font mr-3"
                    style="height: 2.25rem !important;"
                    @click="gotoGoSaas()"
                  >
                    <i class="fa-solid fa-circle-arrow-right mr-1" />{{ $t("Manage Integration") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-ddd btn-normal-font"
                    data-dismiss="modal"
                    style="height: 2.25rem !important;"
                    @click="closeModal()"
                  >
                    {{ $t("Cancel") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { USER } from '@/vuex-store/types'

export default {
  data() {
    return {
      isShow: false,
    };
  },
  computed: {
    ...mapGetters({
      user: USER
    }),
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.$store.state.showedPageDisconnected && this.$store.state.itemsPageDisconnected.length) {
        // $('#alertdisconnectedpages').modal('show');
        this.isShow = true;
      }
    })
  },
  watch: {
    "$store.state.itemsPageDisconnected"() {
      if (!this.$store.state.showedPageDisconnected && this.$store.state.itemsPageDisconnected.length) {
        // console.log($('#alertdisconnectedpages'), $(this.$refs.alertdisconnectedpages))
        if ($('#alertdisconnectedpages')) $('#alertdisconnectedpages').modal('show');
        if ($(this.$refs.alertdisconnectedpages)) $(this.$refs.alertdisconnectedpages).modal('show');
        this.isShow = true;
      }
    }
  },
  methods: {
    closeModal() {
      this.$store.state.showedPageDisconnected = true;
      if ($('#alertdisconnectedpages')) $('#alertdisconnectedpages').modal('hide');
      if ($(this.$refs.alertdisconnectedpages)) $(this.$refs.alertdisconnectedpages).modal('hide');
      this.isShow = false;
    },
    gotoGoSaas() {
      let self = this;
      if (self.$cookie.get("callbackUrl")) window.open(self.$cookie.get("callbackUrl") + "/app/integrations", '_blank').focus();
      else if (process.env.GOSAAS_BASE_URL) window.open(process.env.GOSAAS_BASE_URL, '_blank').focus();
    },
  }
}
</script>

<style scoped>
.modal-content {
  padding: 20px !important;
}

.title-alert-disconnect {
  font-size: 17px;
  font-weight: 500;
  line-height: 20px;
  color: #515151;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalDisconnectedPages.vue